import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeComponentCodeFields {
  internalName?: EntryFieldTypes.Symbol
  body: EntryFieldTypes.Text
  language?: EntryFieldTypes.Symbol<
    | 'Bash'
    | 'C#'
    | 'C++'
    | 'Go'
    | 'HTML'
    | 'Java'
    | 'JavaScript'
    | 'PHP'
    | 'Plain Text'
    | 'Python'
    | 'Ruby'
    | 'Rust'
    | 'XML'
    | 'YAML'
  >
  wordWrap?: EntryFieldTypes.Boolean
}

export type TypeComponentCodeSkeleton = EntrySkeletonType<TypeComponentCodeFields, 'componentCode'>
export type TypeComponentCode<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeComponentCodeSkeleton,
  Modifiers,
  Locales
>

export function isTypeComponentCode<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeComponentCode<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'componentCode'
}
